import { useQuery } from "@tanstack/react-query";
import { getNeighbourhoodSuggestions, NeighbourhoodSuggestionResult } from "../../apis/search";

/**
 * Hook to fetch all neighborhood suggestions
 * Used for the expanded "All Neighborhoods" view
 * @param enabled - Whether to fetch data (only enabled when expanded view is active)
 */
export function useAllNeighborhoodSuggestions(enabled: boolean = false) {
  return useQuery<NeighbourhoodSuggestionResult, Error>({
    queryKey: ["allNeighbourhoodSuggestions"],
    queryFn: () => getNeighbourhoodSuggestions(),
    enabled, // Only fetch when expanded view is active
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
